import { IPicklistApiClient } from "../../PicklistApiClient/IPicklistApiClient";
import { buildPicklistRequest } from "../../PicklistApiClient/PicklistRequestV2Builder";
import { PicklistResultV2 } from "../../PicklistApiClient/Types/PicklistResultV2";

import { DigestRequest } from "./Types/DigestRequest";
import { IDigestApiClient } from "./IDigestApiClient";

export class DigestApiClient implements IDigestApiClient {
    private readonly picklistApiClient: IPicklistApiClient;

    public constructor(httpClient: IPicklistApiClient) {
        this.picklistApiClient = httpClient;
    }

    public async getDigest(request: Readonly<DigestRequest>): Promise<PicklistResultV2> {
        const requestV2 = buildPicklistRequest(request.filter);
        const result = await this.picklistApiClient.searchAsync(request.gId, requestV2);
        return result;
    }
}
